import { useCallback, useEffect, useState } from "react";
import * as flightRequestApi from "Api/flightModifyRequestAPI";
import { groupModifyRequestChains } from "./flightRequestParts";

/**
 * Every booking's FLIGHT manual requests — modifications and cancellations —
 * for the Requests pages (both portals) and the CRM sidebar count, one chain
 * per request + its re-quote rounds (the booking Request tab's rows).
 * `partnerCode` keeps a partner to its own bookings (the `list` filter; the
 * mock filters here). Looks again every `pollMs`, so a new request shows up
 * without a reload; a failed look keeps the rows already shown.
 */
export default function useAllFlightRequests({ partnerCode, pollMs = 30000 } = {}) {
  const [state, setState] = useState({ chains: [], loading: true });

  const refresh = useCallback(async () => {
    const result = await flightRequestApi.listAllModifyRequests({ partnerCode });
    if (!result?.ok) {
      setState((p) => ({ ...p, loading: false }));
      return;
    }
    const requests = flightRequestApi
      .extractModifyRequests(result)
      .filter((r) => !partnerCode || !r.partnerCode || String(r.partnerCode) === String(partnerCode));
    setState({ chains: groupModifyRequestChains(requests), loading: false });
  }, [partnerCode]);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, pollMs);
    return () => clearInterval(id);
  }, [refresh, pollMs]);

  return { ...state, refresh };
}
